// extracted by mini-css-extract-plugin
module.exports = {"title":"title___3WyFn","TipsSettings":"TipsSettings___o5Ja7"};